import { Component, OnInit } from '@angular/core';
import { DiscountView } from 'src/app/Models/ops';

@Component({
  selector: 'app-spra-discount-view',
  templateUrl: './spra-discount-view.component.html',
  styleUrls: ['./spra-discount-view.component.css']
})
export class SpraDiscountViewComponent implements OnInit {
 // public SpraDiscountView: Array<DiscountView> = [];
  public SpraDiscountView: DiscountView
  constructor() { 
    this.SpraDiscountView = new DiscountView();
    //this.SpraDiscountView.push(new DiscountView());
  }

  ngOnInit(): void {
  }
    
}
